import UI from "./core_modules/UI.class"
import Carousel from "./core_modules/carousel"
import CmsPages from "./core_modules/cmsPages.class"
import LogoSlider from "./core_modules/logoSlider.class"
import Modal from "./core_modules/modal"
import Navigation from "./core_modules/navigation.class"

class App {
	private navigation = Navigation.instance
	private logoSlider = LogoSlider.instance
	private modal = Modal.instance
	private cmsPages = CmsPages.instance
	private ui = UI.instance
	private carousel = new Carousel('.carousel-slides', {
		speed: 4500,
		hasControls: true
	})

	constructor() {
		this.initApp()
	}

	/* Register your functions here */
	private initApp(): void {
		this.ui.scrollWatcher()
		this.setHeaderShadow()
		this.expandSearchBar()
		this.handleCloseSearchBar()

		this.cmsPages.removeEmptyElementTags("p")
		this.cmsPages.setElementClassProperty("table", "table")
		this.cmsPages.removeAttributes('table', 'border', 'cellspacing')
		this.cmsPages.removeAttributes('table td', 'style')

		// this.expandSearchBar()
		// this.handleCloseSearchBar()
		this.handleDetailsTagState()
	}

	private searchInputToggler(attribute: string) {
		return this.ui.searchInput.toggleAttribute(attribute)
	}

	private removeAttribute(element: HTMLElement, attribute: string) {
		return element.removeAttribute(attribute)
	}

	private removeClass(element: HTMLElement, attribute: string) {
		return element.classList.remove(attribute)
	}

	private checkInputAttribute(attribute: string) {
		return this.ui.searchInput?.hasAttribute(attribute)
	}

	private searchInputAriaExpandedAttribute(state: string) {
		this.ui.searchInput.setAttribute("aria-expanded", state)
	}

	private get navWidth() {
		const width = this.ui.navElement.getBoundingClientRect().width
		return width
	}

	private get headerHeight() {
		const height = this.ui.header.getBoundingClientRect().height
		return height
	}

	private get pageNavHeight() {
		const height = this.ui.header.getBoundingClientRect().height
		return height
	}

	/**
	 * @description Function set a box shadow on header when past scroll a certain point.
	 */
	private setHeaderShadow(): void {

		/* The callback that will fire on intersection */
		const onIntersect = (entries: IntersectionObserverEntry[]) => {
			entries.forEach(entry => {
				this.ui.header.toggleAttribute("js-header-box-shadow", !entry.isIntersecting)

				if (this.ui.pageNav) {
					if (this.ui.header.hasAttribute("js-header-box-shadow")) {
						this.ui.pageNav.style.backgroundColor = 'var(--bs-white)'
					} else {
						this.ui.pageNav.style.backgroundColor = 'transparent'
					}
				}
			});
		}

		const observer = new IntersectionObserver(onIntersect)

		observer.observe(this.ui.headerIntersect)
	}

	/**
	 * @description Function handles expanding search bar for bigger screens
	 */
	private expandSearchBar(): void {
		const submitButton = document.querySelector("[js-submit-btn]") as HTMLButtonElement

		this.ui.searchButton.addEventListener("click", (e) => {
			e.preventDefault()
			e.stopImmediatePropagation()

			if (window.innerWidth < 800) return

			const target = e.target as HTMLElement

			this.searchInputToggler("search-input-expanded")

			if (this.ui.searchInput.hasAttribute("search-input-expanded")) {
				this.searchInputAriaExpandedAttribute("true")
				this.ui.searchElement.classList.add("hide-menus")
				this.ui.searchButton.style.display = "none";
				submitButton.style.display = "block";
			} else {
				this.searchInputAriaExpandedAttribute("false")
				this.removeClass(this.ui.searchElement, "hide-menus")
				this.ui.searchButton.style.display = "block";
			}

		})
		submitButton.style.display = "none";

	}

	private handleCloseSearchBar(): void {
		const submitButton = document.querySelector("[js-submit-btn]") as HTMLButtonElement

		document.addEventListener("click", (e) => {
			const target = e.target as HTMLElement

			// if (target.tagName === "BUTTON" || target.tagName === "svg" || target.tagName === "use") {
			// 	return
			// }

			if (target === this.ui.searchInput) return

			this.ui.searchElement.classList.remove("hide-menus")
			this.ui.searchInput.setAttribute("aria-expanded", "false")
			this.ui.searchInput.removeAttribute("search-input-expanded")
			submitButton.style.display = "none";
			this.ui.searchButton.removeAttribute("style")
		})

	}

	/**
	* @description Function handles open and close state of the details Tag
	* Only one detail tag should be open on page.
	*/
	private handleDetailsTagState(): void {
		const details = this.ui.detailsTag?.querySelectorAll('details')

		if (details) {
			details.forEach(function (detailEl) {
				detailEl.addEventListener('click', function () {
					const detailsOpen = document.querySelectorAll('details[open]')
					for (const detail of detailsOpen) {
						if (this !== detail) {
							detail.removeAttribute('open')
						}

					}

				})
			})
		}
	}

}

export const myApp = new App();
